// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BorderInnerOutlinedSvg from "@fishx/icons-svg/es/asn/BorderInnerOutlined";
import FishxIcon from '../components/FishxIcon';

var BorderInnerOutlined = function BorderInnerOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: BorderInnerOutlinedSvg
  }));
};

BorderInnerOutlined.displayName = 'BorderInnerOutlined';
export default React.forwardRef(BorderInnerOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/BorderInnerOutlined.js
// module id = 2089
// module chunks = 0